import { allOperators } from "core/components/QueryBuilder/constants";
import {
  faCheck,
  faEllipsis,
  faExclamation,
  faClose,
  faBan,
} from "@fortawesome/pro-solid-svg-icons";

export const stateOptions = [
  {
    name: "AL",
    value: "AL",
    label: "AL",
  },
  {
    name: "AK",
    value: "AK",
    label: "AK",
  },
  {
    name: "AS",
    value: "AS",
    label: "AS",
  },
  {
    name: "AZ",
    value: "AZ",
    label: "AZ",
  },
  {
    name: "AR",
    value: "AR",
    label: "AR",
  },
  {
    name: "CA",
    value: "CA",
    label: "CA",
  },
  {
    name: "CO",
    value: "CO",
    label: "CO",
  },
  {
    name: "CT",
    value: "CT",
    label: "CT",
  },
  {
    name: "DE",
    value: "DE",
    label: "DE",
  },
  {
    name: "DC",
    value: "DC",
    label: "DC",
  },
  {
    name: "FM",
    value: "FM",
    label: "FM",
  },
  {
    name: "FL",
    value: "FL",
    label: "FL",
  },
  {
    name: "GA",
    value: "GA",
    label: "GA",
  },
  {
    name: "GU",
    value: "GU",
    label: "GU",
  },
  {
    name: "HI",
    value: "HI",
    label: "HI",
  },
  {
    name: "ID",
    value: "ID",
    label: "ID",
  },
  {
    name: "IL",
    value: "IL",
    label: "IL",
  },
  {
    name: "IN",
    value: "IN",
    label: "IN",
  },
  {
    name: "IA",
    value: "IA",
    label: "IA",
  },
  {
    name: "KS",
    value: "KS",
    label: "KS",
  },
  {
    name: "KY",
    value: "KY",
    label: "KY",
  },
  {
    name: "LA",
    value: "LA",
    label: "LA",
  },
  {
    name: "ME",
    value: "ME",
    label: "ME",
  },
  {
    name: "MH",
    value: "MH",
    label: "MH",
  },
  {
    name: "MD",
    value: "MD",
    label: "MD",
  },
  {
    name: "MA",
    value: "MA",
    label: "MA",
  },
  {
    name: "MI",
    value: "MI",
    label: "MI",
  },
  {
    name: "MN",
    value: "MN",
    label: "MN",
  },
  {
    name: "MS",
    value: "MS",
    label: "MS",
  },
  {
    name: "MO",
    value: "MO",
    label: "MO",
  },
  {
    name: "MT",
    value: "MT",
    label: "MT",
  },
  {
    name: "NE",
    value: "NE",
    label: "NE",
  },
  {
    name: "NV",
    value: "NV",
    label: "NV",
  },
  {
    name: "NH",
    value: "NH",
    label: "NH",
  },
  {
    name: "NJ",
    value: "NJ",
    label: "NJ",
  },
  {
    name: "NM",
    value: "NM",
    label: "NM",
  },
  {
    name: "NY",
    value: "NY",
    label: "NY",
  },
  {
    name: "NC",
    value: "NC",
    label: "NC",
  },
  {
    name: "ND",
    value: "ND",
    label: "ND",
  },
  {
    name: "MP",
    value: "MP",
    label: "MP",
  },
  {
    name: "OH",
    value: "OH",
    label: "OH",
  },
  {
    name: "OK",
    value: "OK",
    label: "OK",
  },
  {
    name: "OR",
    value: "OR",
    label: "OR",
  },
  {
    name: "PW",
    value: "PW",
    label: "PW",
  },
  {
    name: "PA",
    value: "PA",
    label: "PA",
  },
  {
    name: "PR",
    value: "PR",
    label: "PR",
  },
  {
    name: "RI",
    value: "RI",
    label: "RI",
  },
  {
    name: "SC",
    value: "SC",
    label: "SC",
  },
  {
    name: "SD",
    value: "SD",
    label: "SD",
  },
  {
    name: "TN",
    value: "TN",
    label: "TN",
  },
  {
    name: "TX",
    value: "TX",
    label: "TX",
  },
  {
    name: "UT",
    value: "UT",
    label: "UT",
  },
  {
    name: "VT",
    value: "VT",
    label: "VT",
  },
  {
    name: "VI",
    value: "VI",
    label: "VI",
  },
  {
    name: "VA",
    value: "VA",
    label: "VA",
  },
  {
    name: "WA",
    value: "WA",
    label: "WA",
  },
  {
    name: "WV",
    value: "WV",
    label: "WV",
  },
  {
    name: "WI",
    value: "WI",
    label: "WI",
  },
  {
    name: "WY",
    value: "WY",
    label: "WY",
  },
].sort((a, b) => (a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1));

export const mockAttributeOptions = [
  {
    label: "Item 1",
    value: "Item 1",
  },
  {
    label: "Item 2",
    value: "Item 2",
  },
  {
    label: "Item 3",
    value: "Item 3",
  },
  {
    label: "Item 4",
    value: "Item 4",
  },
];

export const mockModelOptions = [
  {
    name: "Model 1",
    value: "model-1",
    label: "Model 1",
  },
  {
    name: "Model 2",
    value: "model-2",
    label: "Model 2",
  },
  {
    name: "Model 3",
    value: "model-3",
    label: "Model 3",
  },
];

export const mockQueryBuilderFields = [
  {
    inputType: "text",
    label: "Name",
    name: "name",
    operators: allOperators,
    value: "name",
  },
  {
    inputType: "number",
    label: "Age",
    name: "age",
    operators: allOperators,
    value: "age",
  },
  {
    inputType: "text",
    label: "Gender",
    name: "gender",
    operators: allOperators,
    value: "gender",
  },
  {
    inputType: "select",
    label: "State",
    name: "state",
    operators: allOperators,
    value: "state",
    valueEditorType: "multiselect",
    values: stateOptions,
  },
  {
    dateType: "date",
    inputType: "date",
    label: "Date",
    name: "date",
    operators: allOperators,
    value: "date",
    valueEditorType: "date",
  },
  {
    dateType: "month",
    inputType: "date",
    label: "Month",
    name: "month",
    operators: allOperators,
    value: "month",
    valueEditorType: "date",
  },
  {
    dateType: "year",
    inputType: "date",
    label: "Year",
    name: "year",
    operators: allOperators,
    value: "year",
    valueEditorType: "date",
  },
  {
    dateType: "quarter",
    inputType: "date",
    label: "Quarter",
    name: "quarter",
    operators: allOperators,
    value: "quarter",
    valueEditorType: "date",
  },
  {
    inputType: "number",
    label: "Decile",
    name: "decile",
    operators: allOperators,
    value: "decile",
  },
  {
    inputType: "number",
    label: "Decile",
    name: "decile",
    operators: allOperators,
    value: "decile",
  },
  {
    inputType: "zip",
    label: "Zipcodes",
    name: "zip",
    operators: allOperators,
    value: "zip",
  },
];

export const PRODUCT_IDS = {
  IDENTIFIED_CONSUMERS: "identified_consumers",
  DE_IDENTIFIED_CONSUMERS: "deidentified_consumers",
  PROPENSITY_MODELS: "propensity_models",
  NEW_MOVERS: "new_movers",
  MARKET_VOLUME_LITE: "market_volume_lite",
  PROVIDER_AFFILIATIONS: "provider_affiliations",
  PROVIDER_PATHWAYS: "provider_pathways",
  PROVIDER_BENCHMARKS: "provider_benchmarks",
  MARKET_VOLUME: "market_volume",
  CLAIM_VOLUME: "claim_volume",
  PATIENT_VOLUME: "patient_volume",
  MARKET_VOLUME_ONCOLOGY: "market_volume_oncology",
  PRICE_TRANSPARENCY: "price_transparency",
  MARKET_FORECAST: "market_forecast",
  PROVIDER_DIRECTORY: "provider_directory",
};

export const PRODUCT_BUNDLE_IDS = {
  POP_INTEL: "population_intelligence",
  NET_INTEL: "network_intelligence",
  MARK_INTEL: "market_intelligence",
  MARK_FORECAST: "market_forecast",
  PROV_INTEL: "provider_intelligence",
};

export const PRODUCT_BUNDLES = {
  [PRODUCT_BUNDLE_IDS.POP_INTEL]: {
    id: "population_intelligence",
    path: "population-intelligence",
    name: "Population Intelligence",
  },
  [PRODUCT_BUNDLE_IDS.PROV_INTEL]: {
    id: "provider_intelligence",
    path: "provider-intelligence",
    name: "Provider Intelligence",
  },
  [PRODUCT_BUNDLE_IDS.NET_INTEL]: {
    id: "network_intelligence",
    path: "network-intelligence",
    name: "Network Intelligence",
  },
  [PRODUCT_BUNDLE_IDS.MARK_INTEL]: {
    id: "market_intelligence",
    path: "market-intelligence",
    name: "Market Intelligence",
  },
  [PRODUCT_BUNDLE_IDS.MARK_FORECAST]: {
    id: "market_forecast",
    path: "market-forceast",
    name: "Market Forecast",
  },
};

export const MAX_CHIPS = 5;
export const MAX_CHIPS_ADDED = 3;
export const MAX_CHIPS_REMOVED = 3;

export const API_DATE_FORMAT = "yyyy-MM-dd";

export const LEGEND_VARIANTS = {
  POSITIVE: "positive",
  NEGATIVE: "negative",
  MODIFIED: "modified",
  UNMODIFIED: "unmodified",
};

export const SETTINGS = {
  ANONYMIZE_DATA: "anonymize-data",
  ATTRIBUTES: "attributes",
  CONSUMER_RECORDS: "consumer-records",
  RECORDS: "records",
  STATES: "states",
  ZIPCODES: "zipcodes",
  MODELS: "models",
  QUERY: "query",
  QUARTERS: "quarters",
  MONTHS: "months",
  YEARS: "years",
  TOGGLE: "isEnabled",
};

export const FIELDS = {
  [PRODUCT_BUNDLE_IDS.POP_INTEL]: {
    [PRODUCT_IDS.IDENTIFIED_CONSUMERS]: {
      [SETTINGS.ANONYMIZE_DATA]: "isAnonymized",
      [SETTINGS.ATTRIBUTES]: "attributeLimit,purchasedAttributes",
      [SETTINGS.CONSUMER_RECORDS]: "recordLimit",
      [SETTINGS.STATES]: "states",
      [SETTINGS.ZIPCODES]: "zipcodes",
      [SETTINGS.QUERY]: "consumerFilters",
    },
    [PRODUCT_IDS.DE_IDENTIFIED_CONSUMERS]: {
      [SETTINGS.STATES]: "states",
    },
    [PRODUCT_IDS.PROPENSITY_MODELS]: {
      [SETTINGS.MODELS]: "modelLimit,selectedModels",
    },
    [PRODUCT_IDS.NEW_MOVERS]: {
      [SETTINGS.RECORDS]: "recordLimit",
      [SETTINGS.STATES]: "states",
      [SETTINGS.QUERY]: "moverFilters",
    },
    [PRODUCT_IDS.MARKET_VOLUME_LITE]: {
      [SETTINGS.MONTHS]: "licensedDates",
      [SETTINGS.STATES]: "states",
    },
  },
  [PRODUCT_BUNDLE_IDS.NET_INTEL]: {
    [PRODUCT_IDS.PROVIDER_AFFILIATIONS]: {
      [SETTINGS.QUARTERS]: "licensedDates",
    },
    [PRODUCT_IDS.PROVIDER_PATHWAYS]: {
      [SETTINGS.MONTHS]: "licensedDates",
      [SETTINGS.STATES]: "states",
    },
    [PRODUCT_IDS.PROVIDER_BENCHMARKS]: {
      [SETTINGS.QUARTERS]: "licensedDates",
    },
  },
  [PRODUCT_BUNDLE_IDS.MARK_INTEL]: {
    [PRODUCT_IDS.MARKET_VOLUME]: {
      [SETTINGS.MONTHS]: "licensedDates",
      [SETTINGS.STATES]: "states",
    },
    [PRODUCT_IDS.CLAIM_VOLUME]: {
      [SETTINGS.MONTHS]: "licensedDates",
      [SETTINGS.STATES]: "states",
    },
    [PRODUCT_IDS.PATIENT_VOLUME]: {
      [SETTINGS.YEARS]: "licensedDates",
      [SETTINGS.STATES]: "states",
    },
    [PRODUCT_IDS.MARKET_VOLUME_ONCOLOGY]: {
      [SETTINGS.MONTHS]: "licensedDates",
      [SETTINGS.STATES]: "states",
    },
    [PRODUCT_IDS.PRICE_TRANSPARENCY]: {
      [SETTINGS.QUARTERS]: "licensedDates",
    },
  },
  [PRODUCT_BUNDLE_IDS.MARK_FORECAST]: {
    [PRODUCT_IDS.MARKET_FORECAST]: {
      [SETTINGS.YEARS]: "licensedDates",
      [SETTINGS.STATES]: "states",
    },
  },
  [PRODUCT_BUNDLE_IDS.PROV_INTEL]: {
    [PRODUCT_IDS.PROVIDER_DIRECTORY]: {
      //   [SETTINGS.TOGGLE]: "isEnabled",
    },
  },
};

export const defaultLicenseState = {
  // Market Forecast
  [PRODUCT_IDS.MARKET_FORECAST]: {
    enabled: false,
    license: {
      geography: { states: null },
      dates: null,
    },
  },

  // Population Intelligence
  [PRODUCT_IDS.IDENTIFIED_CONSUMERS]: {
    enabled: false,
    license: {
      // First section
      anonymized_records: false,

      // Second section
      identified_consumer_attribute_limit: 0,

      // Third section
      identified_consumer_record_limit: 0,
      geography: { states: null, zips: [] },
      identified_consumer_filters: [],
      data: { consumer: { licensed_field_group_ids: [] } },
    },
  },
  [PRODUCT_IDS.DE_IDENTIFIED_CONSUMERS]: {
    enabled: false,
    license: {
      geography: { states: null },
    },
  },
  [PRODUCT_IDS.PROPENSITY_MODELS]: {
    enabled: false,
    license: {
      model_limit: 0,
      selected_models: [],
    },
  },
  [PRODUCT_IDS.NEW_MOVERS]: {
    enabled: false,
    license: {
      new_mover_record_limit: 0,
      new_mover_filters: [],
      geography: {
        states: null,
        zips: [],
      },
    },
  },
  [PRODUCT_IDS.MARKET_VOLUME_LITE]: {
    enabled: false,
    license: {
      geography: { states: null },
      dates: null,
    },
  },

  // Provider Intelligence
  [PRODUCT_IDS.PROVIDER_DIRECTORY]: {
    enabled: false,
    license: {},
  },

  // Network Intelligence
  [PRODUCT_IDS.PROVIDER_AFFILIATIONS]: {
    enabled: false,
    license: {
      dates: null,
    },
  },
  [PRODUCT_IDS.PROVIDER_PATHWAYS]: {
    enabled: false,
    license: {
      geography: { states: null },
      dates: null,
    },
  },
  [PRODUCT_IDS.PROVIDER_BENCHMARKS]: {
    enabled: false,
    license: {
      dates: null,
    },
  },
  [PRODUCT_IDS.MARKET_VOLUME]: {
    enabled: false,
    license: {
      geography: { states: null },
      dates: null,
    },
  },
  [PRODUCT_IDS.CLAIM_VOLUME]: {
    enabled: false,
    license: {
      geography: { states: null },
      dates: null,
    },
  },

  // Market Intelligence
  [PRODUCT_IDS.PATIENT_VOLUME]: {
    enabled: false,
    license: {
      geography: { states: null },
      dates: null,
    },
  },
  [PRODUCT_IDS.MARKET_VOLUME_ONCOLOGY]: {
    enabled: false,
    license: {
      geography: { states: null },
      dates: null,
    },
  },
  [PRODUCT_IDS.PRICE_TRANSPARENCY]: {
    enabled: false,
    license: {
      dates: null,
    },
  },
};

export const productIds = Object.keys(defaultLicenseState);

export const DEPLOYMENT_STATUSES = {
  DEFAULT: "Not Configured",
  SUCCESS: "Deployed",
  IN_PROGRESS: "In Progress",
  FAILED: "Failed",
  QUEUED: "Queued",
  TIMEOUT: "Timeout",
  UNKNOWN: "Unknown",
};

export const DEPLOYMENT_STATUS_MAP = {
  "not deployed": DEPLOYMENT_STATUSES.DEFAULT,
  "in progress": DEPLOYMENT_STATUSES.IN_PROGRESS,
  queued: DEPLOYMENT_STATUSES.QUEUED,
  succeeded: DEPLOYMENT_STATUSES.SUCCESS,
  failed: DEPLOYMENT_STATUSES.FAILED,
  timeout: DEPLOYMENT_STATUSES.TIMEOUT,
  unknown: DEPLOYMENT_STATUSES.UNKNOWN,
};

export const DEPLOYMENT_STATUS_PILL_VARIANTS = {
  [DEPLOYMENT_STATUSES.DEFAULT]: "default",
  [DEPLOYMENT_STATUSES.SUCCESS]: "success",
  [DEPLOYMENT_STATUSES.IN_PROGRESS]: "info",
  [DEPLOYMENT_STATUSES.FAILED]: "failed",
  [DEPLOYMENT_STATUSES.QUEUED]: "pending",
  [DEPLOYMENT_STATUSES.TIMEOUT]: "failed",
  [DEPLOYMENT_STATUSES.UNKNOWN]: "warning",
};

// TODO: These enums belong with the querybuilder
export const FIELD_TYPES = {
  INT64: "number",
  FLOAT64: "number",
  STRING: "text",
  DATE: "date",
  SELECT: "select",
  ZIPCODE: "zip",
};

export const DATE_TYPES = {
  DATE: "date",
  MONTH: "month",
  YEAR: "year",
  QUARTER: "quarter",
};

export const VALUE_EDITOR_TYPES = {
  DATE: "date",
  MULTISELECT: "multiselect",
};

export const jsonTheme = {
  scheme: "google",
  author: "seth wright (http://sethawright.com)",
  base00: "#1d1f21",
  base01: "#282a2e",
  base02: "#373b41",
  base03: "#969896",
  base04: "#b4b7b4",
  base05: "#c5c8c6",
  base06: "#e0e0e0",
  base07: "#ffffff",
  base08: "#CC342B",
  base09: "#ff2a00",
  base0A: "#FBA922",
  base0B: "#008844",
  base0C: "#3971ED",
  base0D: "#3971ED",
  base0E: "#A36AC7",
  base0F: "#3971ED",
};

export const tooltipId = "statusTooltip";
export const dateTimeFormat = "FF";

export const ipsumDescriptum =
  "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu.";

export const REVIEW_FIELD_MAPPING = {
  [PRODUCT_IDS.IDENTIFIED_CONSUMERS]: {
    anonymized_records: SETTINGS.ANONYMIZE_DATA,
    identified_consumer_attribute_limit: SETTINGS.ATTRIBUTES,
    licensed_field_group_ids: SETTINGS.ATTRIBUTES,
    identified_consumer_record_limit: SETTINGS.CONSUMER_RECORDS,
    identified_consumer_filters: SETTINGS.QUERY,
    states: SETTINGS.STATES,
    zips: SETTINGS.ZIPCODES,
    enabled: SETTINGS.TOGGLE,
  },
  [PRODUCT_IDS.DE_IDENTIFIED_CONSUMERS]: {
    states: SETTINGS.STATES,
    enabled: SETTINGS.TOGGLE,
  },
  [PRODUCT_IDS.PROPENSITY_MODELS]: {
    model_limit: SETTINGS.MODELS,
    selected_models: SETTINGS.MODELS,
    enabled: SETTINGS.TOGGLE,
  },
  [PRODUCT_IDS.NEW_MOVERS]: {
    new_mover_record_limit: SETTINGS.RECORDS,
    states: SETTINGS.STATES,
    new_mover_filters: SETTINGS.QUERY,
    enabled: SETTINGS.TOGGLE,
  },
  [PRODUCT_IDS.MARKET_VOLUME_LITE]: {
    states: SETTINGS.STATES,
    dates: SETTINGS.MONTHS,
    from: SETTINGS.MONTHS,
    to: SETTINGS.MONTHS,
    enabled: SETTINGS.TOGGLE,
  },
  [PRODUCT_IDS.PROVIDER_AFFILIATIONS]: {
    dates: SETTINGS.QUARTERS,
    from: SETTINGS.QUARTERS,
    to: SETTINGS.QUARTERS,
    enabled: SETTINGS.TOGGLE,
  },
  [PRODUCT_IDS.PROVIDER_PATHWAYS]: {
    states: SETTINGS.STATES,
    dates: SETTINGS.MONTHS,
    from: SETTINGS.MONTHS,
    to: SETTINGS.MONTHS,
    enabled: SETTINGS.TOGGLE,
  },
  [PRODUCT_IDS.PROVIDER_BENCHMARKS]: {
    dates: SETTINGS.QUARTERS,
    from: SETTINGS.QUARTERS,
    to: SETTINGS.QUARTERS,
    enabled: SETTINGS.TOGGLE,
  },
  [PRODUCT_IDS.MARKET_VOLUME]: {
    states: SETTINGS.STATES,
    dates: SETTINGS.MONTHS,
    from: SETTINGS.MONTHS,
    to: SETTINGS.MONTHS,
    enabled: SETTINGS.TOGGLE,
  },
  [PRODUCT_IDS.CLAIM_VOLUME]: {
    states: SETTINGS.STATES,
    dates: SETTINGS.MONTHS,
    from: SETTINGS.MONTHS,
    to: SETTINGS.MONTHS,
    enabled: SETTINGS.TOGGLE,
  },
  [PRODUCT_IDS.PATIENT_VOLUME]: {
    states: SETTINGS.STATES,
    dates: SETTINGS.YEARS,
    from: SETTINGS.YEARS,
    to: SETTINGS.YEARS,
    enabled: SETTINGS.TOGGLE,
  },
  [PRODUCT_IDS.MARKET_VOLUME_ONCOLOGY]: {
    states: SETTINGS.STATES,
    dates: SETTINGS.MONTHS,
    from: SETTINGS.MONTHS,
    to: SETTINGS.MONTHS,
    enabled: SETTINGS.TOGGLE,
  },
  [PRODUCT_IDS.PRICE_TRANSPARENCY]: {
    dates: SETTINGS.QUARTERS,
    from: SETTINGS.QUARTERS,
    to: SETTINGS.QUARTERS,
    enabled: SETTINGS.TOGGLE,
  },
  [PRODUCT_IDS.MARKET_FORECAST]: {
    states: SETTINGS.STATES,
    dates: SETTINGS.YEARS,
    enabled: SETTINGS.TOGGLE,
  },
  [PRODUCT_IDS.PROVIDER_DIRECTORY]: {
    enabled: SETTINGS.TOGGLE,
  },
};

export const ONBOARDING_LABELS = {
  "not onboarded": "Not Setup",
  timeout: "Timeout",
  "in progress": "In Progress",
  succeeded: "Active",
  failed: "Error",
  inactive: "Inactive",
  queued: "Queued",
  unknown: "Unknown",
};

export const ONBOARDING_ICONS = {
  "not onboarded": faExclamation,
  timeout: faClose,
  "in progress": faEllipsis,
  succeeded: faCheck,
  failed: faClose,
  queued: faEllipsis,
  unknown: faExclamation,
  inactive: faBan,
};

export const ONBOARDING_VARIANTS = {
  "not onboarded": "default",
  timeout: "failed",
  "in progress": "info",
  succeeded: "success",
  failed: "failed",
  queued: "pending",
  unknown: "warning",
  inactive: "default",
};

export const DEPLOYMENT_ICONS = {
  [DEPLOYMENT_STATUSES.DEFAULT]: faExclamation,
  [DEPLOYMENT_STATUSES.SUCCESS]: faCheck,
  [DEPLOYMENT_STATUSES.IN_PROGRESS]: faEllipsis,
  [DEPLOYMENT_STATUSES.FAILED]: faClose,
  [DEPLOYMENT_STATUSES.QUEUED]: faEllipsis,
  [DEPLOYMENT_STATUSES.TIMEOUT]: faClose,
  [DEPLOYMENT_STATUSES.UNKNOWN]: faExclamation,
};

export const REFETCH_SHORT = 10 * 1000;
export const REFETCH_LONG = 60 * 1000;
export const durationFormat = "m'm ' s's'";

export const OPERATOR_SYMBOL_MAPPING = {
  BETWEEN: "between",
  NOT_BETWEEN: "is not between",
  EQUAL_TO: "=",
  NOT_EQUAL_TO: "!=",
  LESS_THAN: "<",
  GREATER_THAN: ">",
  LESS_THAN_OR_EQUAL_TO: "<=",
  GREATER_THAN_OR_EQUAL_TO: ">=",
  IN: "is in",
  NOT_IN: "is not in",
  IS_NULL: "is null",
  IS_NOT_NULL: "is not null",
};

export const OPERATOR_TEXT_MAPPING = {
  [OPERATOR_SYMBOL_MAPPING.BETWEEN]: "Between",
  [OPERATOR_SYMBOL_MAPPING.NOT_BETWEEN]: "Not Between",
  [OPERATOR_SYMBOL_MAPPING.EQUAL_TO]: "Equal To",
  [OPERATOR_SYMBOL_MAPPING.NOT_EQUAL_TO]: "Not Equal To",
  [OPERATOR_SYMBOL_MAPPING.LESS_THAN]: "Less Than",
  [OPERATOR_SYMBOL_MAPPING.GREATER_THAN]: "Greater Than",
  [OPERATOR_SYMBOL_MAPPING.LESS_THAN_OR_EQUAL_TO]: "Less Than or Equal To",
  [OPERATOR_SYMBOL_MAPPING.GREATER_THAN_OR_EQUAL_TO]:
    "Greater Than or Equal To",
  [OPERATOR_SYMBOL_MAPPING.IN]: "In",
  [OPERATOR_SYMBOL_MAPPING.NOT_IN]: "Not In",
  [OPERATOR_SYMBOL_MAPPING.IS_NULL]: "Is Null",
  [OPERATOR_SYMBOL_MAPPING.IS_NOT_NULL]: "Is Not Null",
};
